const accentBlue = '#2C7ECE';
const accentBlue2 = '#1C5ED9';
const accentPink = '#E30084';
const accentGreen = '#10CF79';
const accentGreen2 = '#6BC733';
const accentOrange = '#FE8232';
const accentYellow = '#FFB106';
const accentPurple = '#7837C6';

const grayMidnight = '#363636';
const graySlate = '#979B9E';
const grayFog2 = '#B7B7B7';
const grayFog = '#CBCBCB';
const grayCloud = '#E4E7EA';
const grayIce = '#F6F6F6';

const danger = '#D01749';

const hexToRgb = (hex) => {
  const hex2 = hex.replace(/#/g, '');
  const r = parseInt(hex2.substring(0, 2), 16);
  const g = parseInt(hex2.substring(2, 4), 16);
  const b = parseInt(hex2.substring(4, 6), 16);
  return [r,g,b];
};

const isDark = (hex) => {
  const [r,g,b] = hexToRgb(hex);
  const sum = r+g+b;
  return sum < 383;
};

export default {
  accentBlue,
  accentBlue2,
  accentPink,
  accentGreen,
  accentGreen2,
  accentOrange,
  accentYellow,
  accentPurple,
  grayMidnight,
  graySlate,
  grayFog2,
  grayFog,
  grayCloud,
  grayIce,
  danger,
  hexToRgb,
  isDark,
};
